import {
  Button,
  Col,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";
import { JsonEditor } from "json-edit-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { IoAddOutline, IoMenu } from "react-icons/io5";
import { addBanner, editBanner, getOfferbyId, uploadBanner } from "./BannerApi";
import countryOptions from "../../../CommonComponents/CountryJson.json";
import unique from "../../../CommonComponents/cleanCountryOption";
import axios from "axios";
function UpdateBanner() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const { Option } = Select;
  const [uploadingIndex, setUploadingIndex] = useState(null);

  const [contentData, setContentData] = useState({});
  const [imageURL, setImageURL] = useState(
    from === "add" ? [] : fill?.variants?.map((i) => i.image)
  );
  const [isLoading, setIsLoading] = useState(false);
  // const handleFileUpload = (e, index) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       const updatedImages = [...imageURL];
  //       updatedImages[index] = reader.result;
  //       setImageURL(updatedImages);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  const handleFileUpload = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingIndex(index);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadBanner(formData);

      const cloudURL = response?.data?.url;
      const updatedURLs = [...imageURL];
      updatedURLs[index] = cloudURL;
      setImageURL(updatedURLs);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setUploadingIndex(null); // Stop loading
    }
  };

  //   function FetchContentDataByID() {
  //     getOfferbyId(`${fill?._id}`)
  //       .then((response) => {
  //         if (response.success) {
  //           setContentData(response.data.content);
  //           form.setFieldsValue(response.data.content);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("error", err);
  //       });
  //   }

  //   const setJSONData = () => {};

  //   useEffect(() => {
  //     FetchContentDataByID();
  //   }, [form]);

  const navigate = useNavigate();

  const AddBanner = (values) => {
    const payload = {
      isActive: values.isActive,
      pageNumber: values.pageNumber,
      variants: values.variants.map((variant, index) => ({
        ...variant,
        image: imageURL[index] || "",
      })),
    };
    setIsLoading(true);
    addBanner(payload)
      .then((response) => {
        if (response.status) {
          navigate("/get/banner_details");
          form.resetFields();
          setImageURL([]);
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const updateContentData = (values) => {
    const payload = {
      isActive: values.isActive,
      pageNumber: values.pageNumber,
      variants: values.variants.map((variant, index) => ({
        countryCode: variant.countryCode,
        redirectLink: variant.redirectLink,
        image: imageURL[index] || "", // fallback if not uploaded
      })),
    };

    setIsLoading(true);
    editBanner(payload, `${fill?._id}`)
      .then((response) => {
        if (response.status) {
          navigate("/get/banner_details");
          form.resetFields();
          setImageURL([]);
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    console.log(result);
    const content = form.getFieldValue("content") || [];
    const newContent = [...content];

    const [movedItem] = newContent.splice(result.source.index, 1);
    newContent.splice(result.destination.index, 0, movedItem);

    form.setFieldsValue({ content: newContent });
  };
  useEffect(() => {
    if (fill) {
      form.setFieldsValue({
        pageNumber: fill.pageNumber,
        isActive: fill.isActive,
        variants: fill.variants,
      });

      // Set initial image URLs per variant
      setImageURL(fill.variants?.map((variant) => variant.image));
    }
  }, [form, fill]);

  return (
    <div>
      <Divider
        orientation="left"
        style={{ border: "#cecece" }}
        className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
      >
        {from === "edit" ? "Update" : "Add"} Banner
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) =>
          from === "add" ? AddBanner(values) : updateContentData(values)
        }
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          {/* <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Redirect Link
                </p>
              }
              name="redirectLink"
            >
              <Input placeholder="e.g.,Your go-to source for course tips, updates, and success stories." />
            </Form.Item>
          </Col> */}
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Page Number
                </p>
              }
              name="pageNumber"
            >
              <Input
                placeholder="e.g., Page Number should be greater then 0"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Active Status
                </p>
              }
              name="isActive"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
            Variants
          </p>
          <Col>
            <Form.Item
              validateTrigger="onSubmit"
              style={{ marginBottom: "16px" }}
            >
              <Form.List name="variants">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }, index) => {
                        return (
                          <div
                            key={key}
                            style={{ marginBottom: "16px" }}
                            className="grid grid-cols-1 sm:grid-cols-[1%_27%_20%_40%_8%] gap-4"
                          >
                            <p className="font-medium">{index + 1}.</p>

                            <Form.Item
                              {...restField}
                              name={[name, "countryCode"]}
                              fieldKey={[fieldKey, "countryCode"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a country",
                                },
                                {
                                  validator: async (_, value) => {
                                    const variants =
                                      form.getFieldValue("variants") || [];

                                    const countryCount = variants.filter(
                                      (item, idx) =>
                                        item?.countryCode === value &&
                                        idx !== index
                                    );

                                    if (countryCount.length > 0) {
                                      throw new Error(
                                        "Country already selected in another variant"
                                      );
                                    }

                                    // Only validate default on the last field
                                    if (index === variants.length - 1) {
                                      const hasDefault = variants.some(
                                        (item) =>
                                          item?.countryCode === "default"
                                      );

                                      // if (!hasDefault) {
                                      //   throw new Error(
                                      //     'At least one variant must have country "default"'
                                      //   );
                                      // }
                                    }

                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Select Country"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option?.children
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                suffixIcon={
                                  <Image src={dropDownImage} preview={false} />
                                }
                                virtual={true} // Enables virtualization (helps with long lists)
                                style={{ width: "100%" }}
                              >
                                {unique.map((option) => (
                                  <Select.Option
                                    key={option.cc}
                                    value={option.cc}
                                  >
                                    {option.country}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              name={[name, "image"]}
                              fieldKey={[fieldKey, "image"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select image",
                                },
                              ]}
                            >
                              <div className="relative rounded-[11px] flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                                {uploadingIndex === index ? (
                                  <Spin />
                                ) : (
                                  <Image
                                    src={imageURL[index]}
                                    height={127}
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: "11px",
                                    }}
                                    preview={false}
                                  />
                                )}

                                <input
                                  type="file"
                                  name="photo"
                                  id={`upload-photo-${index}`}
                                  onChange={(e) => handleFileUpload(e, index)}
                                  className="absolute inset-0 opacity-0 cursor-pointer"
                                />

                                <label
                                  htmlFor={`upload-photo-${index}`}
                                  className="cursor-pointer"
                                >
                                  {from === "edit" ? (
                                    <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center opacity-80" />
                                  ) : (
                                    <IoAddOutline className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[26px] h-[26px] flex justify-center items-center opacity-80" />
                                  )}
                                </label>
                              </div>
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              name={[name, "redirectLink"]}
                              fieldKey={[fieldKey, "redirectLink"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter a Redirect Link",
                                },
                              ]}
                            >
                              <Input placeholder="e.g.,Your go-to source for course tips, updates, and success stories." />
                            </Form.Item>

                            <Button
                              onClick={() => {
                                remove(name);
                                setImageURL((prev) => {
                                  const newArr = [...prev];
                                  newArr.splice(name, 1); // remove the image at the same index
                                  return newArr;
                                });
                              }}
                              className="remove-button NoButtonHover"
                            >
                              Remove
                            </Button>
                          </div>
                        );
                      }
                    )}

                    <Form.Item>
                      <Button
                        className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Variant
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>
        {/*  */}

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                from === "edit"
                  ? navigate("/blog/blogData")
                  : form.resetFields();
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
              htmlType="onSubmit"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              className="NoButtonHover create-button"
              size="small"
              htmlType="submit"
              loading={isLoading}
            >
              {from === "edit" ? "Edit" : "Create"} Banner
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default UpdateBanner;
